import React, { Component } from 'react';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    arrows: false
};

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: false,
            pagecount: 1,
            playerid: null,
            user_id: null,
            point: null,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            tabbannerlist: [],
        }
    }

    componentDidMount() {
        const cacheKey = "tabBannerListCache";
        const cacheTTL = 3 * 60 * 60 * 1000;
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));

        if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
            console.log("Using cached data for tabbannerlist");
            this.setState({ tabbannerlist: cachedData.data });
        } else {
            instance.get("/api/v1/tabbannerlist?System=" + Systems)
                .then((res) => {
                    console.log("tabbannerlist", res.data);

                    if (res.data.status === 200) {
                        this.setState({ tabbannerlist: res.data.message });

                        localStorage.setItem(cacheKey, JSON.stringify({
                            timestamp: Date.now(),
                            data: res.data.message,
                        }));
                    }
                })
                .catch((err) => {
                    console.error("Error fetching tabbannerlist:", err);
                });
        }
    }

    getBannerSrc = (item) => {
        if (!item) return "";

        return (
            item.path ||
            item.image ||
            item.img ||
            item.banner ||
            item.src ||
            item.url ||
            ""
        );
    }

    render() {
        const banners = Array.isArray(this.state.tabbannerlist)
            ? this.state.tabbannerlist
            : [];

        return (
            <section className="carouselSliderSection">
                <Slider {...settings} className="slider">
                    {
                        banners.map((item, index) => {
                            const src = this.getBannerSrc(item);

                            if (!src) return null;

                            return (
                                <div key={index}>
                                    <div
                                        tabIndex={-1}
                                        style={{
                                            width: "100%",
                                            display: "inline-block"
                                        }}
                                    >
                                        <picture>
                                            <img
                                                loading="lazy"
                                                src={src}
                                                className="title-icon"
                                                alt="banner"
                                                id={"home-banner-" + index}
                                                style={{ height: index === 0 ? "3.8rem" : "100%" }}
                                            />
                                        </picture>
                                    </div>
                                </div>
                            );
                        })
                    }
                </Slider>
            </section>
        );
    }
}

export default App;